module.exports = __webpack_public_path__ + "img/pace.411397c9.png";